var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"48","cy":"48","r":"48","fill":"#FFFEFE","key":0}),React.createElement("path",{"d":"M35 31.0033C35 29.4224 36.7477 28.4664 38.0789 29.3192L64.3712 46.1627C65.5994 46.9496 65.5994 48.7441 64.3712 49.5309L38.0789 66.3744C36.7477 67.2272 35 66.2713 35 64.6903V31.0033Z","fill":"#F687B3","key":1})]);
}

Play.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Play;

Play.default = Play;
